<template>
    <div class="columns is-multiline">
        <div class="column is-full">
            <b-table 
            :data="count > 0 ? entries : []"
            :loading="loadingEntries"
            :hoverable="true"
            >
                <template slot-scope="props">
                    <b-table-column field="title" label="Titulo">
                        <a :href="props.row.getStaffForm">{{ props.row.title }}</a>
                    </b-table-column>
                    
                    <b-table-column field="timestamp" label="Creado" centered>
                        <span class="tag is-success">
                            {{ new Date(props.row.timestamp).toLocaleDateString() }}
                        </span>
                    </b-table-column>

                    <b-table-column field="timestamp" label="Visible?" centered>
                        <div class="has-text-centered">
                            <b-icon v-if="props.row.visible" icon="check-circle" class="has-text-success"></b-icon>
                            <b-icon v-else icon="times-circle" class="has-text-light"></b-icon>
                        </div>
                    </b-table-column>
                </template>
            </b-table>
        </div>
        <div class="column is-full has-text-centered m-t-20">
            <b-pagination
                :total="count"
                :per-page="perPage"
                :current.sync="page"
                :range-before="2"
                :rounded="true"
                :range-after="2"
                order="is-centered"
                @change="onPageChange"
                icon-prev="chevron-left"
                icon-next="chevron-right"
            >
            </b-pagination>
        </div>
        <div class="column is-full has-text-centered m-t-20">
            <b-button
            rounded
            type="is-primary"
            @click="redirectToForm">
                <b-icon icon="plus" size="is-small" class="m-r-5"></b-icon>
                Agreger una entrada
            </b-button>
        </div>
    </div>
</template>

<script>
import { getHandler } from '../../../../services/http';

export default {
    props:{
        entryListCreate:{
            type:String,
            default:""
        },
        entryEdit:{
            type:String,
            default:""
        },
        sections:{
            type:Array,
            default:new Array([])
        },
        addEntryForm:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            loadingEntries:false,
            entries:[],
            count:0,
            page:1,
            perPage:24,
            selectedSection:""
        }
    },
    methods:{
        async fetchEntries(){
            var url = this.entryListCreate + `?page=${this.page}`
            if (this.selectedSection.length){
                url = url + `&section=${this.selectedSection}`
            }
            this.loadingEntries = true
            var resp = await getHandler(url, {error:false, success:false})
            this.count = resp.count
            this.entries = resp.results
            this.loadingEntries = false
        },
        onPageChange(page){
            this.page = page
            this.fetchEntries()
        },
        redirectToForm(){
            window.location.href = this.addEntryForm
        }
    },
    created(){
        this.fetchEntries()
    }
}
</script>